import { ViewChild, Component, Inject, Input, OnInit  } from "@angular/core";
import { animate, state, style, transition, trigger } from '@angular/animations';
import { COMMA, ENTER, TAB } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from "@angular/material/chips";
import { MatTable, MatTableDataSource } from "@angular/material/table";
import { Utils } from '../../../utils/utils';
import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { SaveService } from '../../../services/save.service';
import { DialogService } from "../../../services/dialog.service";
import { DefaultValuesService } from '../../../services/defaultvalues.service';
import { inspect } from "util";
import { ChangeHistoryDialogue } from "../dialog-change-history/dialog-change-history";
import { MatDialog } from "@angular/material/dialog";
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: "inspection-list",
    templateUrl: './inspection-list.component.html',
    styleUrls: ['./inspection-list.component.less', '../../../style/mat-table.component.less'],
    standalone: false,
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
            state('expanded', style({ height: '*' })),
            transition('expanded => collapsed', [animate('0ms cubic-bezier(0.4, 0.0, 0.2, 1)')]),
        ]),
    ]
})

export class InspectionListComponent implements OnInit {
    @Input('list') list: InspectionView[] = [];
    @Input('showLocalFilter') showLocalFilter: boolean = false;

    columnsToDisplay = ['arrow', 'index', 'InspectionId', 'UnitId', 'LastInspectionDate', 'NextInspectionDate', 'PeriodOfInspection', '_ChangedAtUtc', 'actions'];

    subcolumnsToDisplay = ['LastInspectionOutcome', 'LastInspectionOutcomeDescriptionLocale', 'DeadlineForRepairs', 'DocumentUri', 'RepairDocumentUri', 'LanguageCultureName', 'IsDeleted'];

    booleanColumns = ['IsDeleted'];
    dateColumns = ['LastInspectionDate', 'NextInspectionDate', '_ChangedAtUtc', 'DeadlineForRepairs'];
    dateColumnsFormatYYYYMMDDHHmm = ['_ChangedAtUtc'];
    numberColumns = [''];

    notEditableColumns = ['InspectionId', 'UnitId', '_ChangedAtUtc'];

    @ViewChild(MatTable, { static: true }) table!: MatTable<any>;

    public dataSource = new MatTableDataSource<InspectionView>();
    selected: InspectionView | undefined;
    expanded: boolean[] = [];
    expandedElements = new Set();
    clonedList: { [s: string]: InspectionView; } = {};

    filter: string = '';

    subscriptionLanguage: any;
    subscriptionTenant: any;

    visible = true;
    selectable = true;
    removable = true;
    addOnBlur = true;
    readonly separatorKeysCodes: number[] = [COMMA, TAB, ENTER];
    searchItems: SearchItem[] = [];

    constructor(private activatedRoute: ActivatedRoute
        , private router: Router
        , private http: HttpClient
        , private saveService: SaveService
        , private confirmDialog: DialogService
        , private defaults: DefaultValuesService
        , @Inject('BASE_URL') private baseUrl: string
        , private dialog: MatDialog
        , private readonly toastrService: ToastrService
    ) {
    }

    ngOnChanges() {
        this.dataSource.data = this.list
        this.clonedList = {}
        this.saveService.showSaveButton(false)
        this.expandedElements.clear();
        this.saveService.addListener(this)
    }

    ngOnInit() {
        this.getHeader();
        this.saveService.addListener(this);
        this.dataSource.filterPredicate = (data: InspectionView, filters: string) => {
            const matchFilter: any[] = [];
            const filterArray = filters.split('+').filter(x => x.indexOf('notextfilters') < 0)
            if (filterArray.length > 0) {
                filterArray.forEach((filter) => {
                    const fields: string[] = []
                    fields.push(data.InspectionId ? data.InspectionId : '')
                    fields.push(data.UnitId ? data.UnitId : '')
                    return matchFilter.push(fields.some(item => item.includes(filter)));
                });
            }
            else {
                let result = true;
                matchFilter.push(result);
            }
            return matchFilter.some(Boolean);
        };
    }

    getHeader() {
        if (!this.defaults.isReadonlyUser)
            this.columnsToDisplay = ['arrow', 'index', 'InspectionId', 'UnitId', 'LastInspectionDate', 'NextInspectionDate', 'PeriodOfInspection', '_ChangedAtUtc', 'actions'];
        else
            this.columnsToDisplay = ['arrow', 'index', 'InspectionId', 'UnitId', 'LastInspectionDate', 'NextInspectionDate', 'PeriodOfInspection', '_ChangedAtUtc'];
        this.subcolumnsToDisplay.sort((x, y) => (x > y ? 1 : -1));
    }

    getInput(data: InspectionView, property: string): any {
        return data[property];
    }

    getDataType(property: string) {
        let result = ''
        if (this.booleanColumns.indexOf(property) > -1) result = 'boolean'
        else if (this.dateColumns.indexOf(property) > -1) result = 'date'
        else if (this.numberColumns.indexOf(property) > -1) result = 'number'
        else result = 'string'
        return result
    }

    changeElement(object: any, type: string, value: boolean) {
        object[type] = value;
        this.table.renderRows();
    }

    pushPopElement(element: InspectionView) {
        if (this.expandedElements.has(element)) {
            this.expandedElements.delete(element);
        }
        else {
            this.expandedElements.add(element);
            this.onExpand(element)
        }
    }

    checkExpanded(element: InspectionView) {
        return this.expandedElements.has(element);
    }

    onExpand(element: InspectionView) {
        let filterDetails: InspectionFilter = {
            'InspectionIds': [element.InspectionId],
            'UnitIds': []
        }
        Utils.httpGetinspectionDetails(
            this.http
            , this.baseUrl
            , this.defaults.stage
            , element.InspectionId
            , element.UnitId
            , this
            , function (tthis: any, list: InspectionDetailsView[]) {
                element.Details = list;
                tthis.expandedElements.add(element);
            }
        );
    }

    isEditingRow(inspection: InspectionView, property: string) {
        return this.clonedList[this.getDictionaryHash(inspection)] &&
            (this.notEditableColumns.indexOf(property) < 0)
    }

    onRowEditInit(inspection: InspectionView) {
        this.saveService.addListener(this);
        this.clonedList[this.getDictionaryHash(inspection)] = { ...inspection };
        if (Object.keys(this.clonedList).length !== 0) this.onShowSavebutton()
        this.table.renderRows();
        if (!this.expandedElements.has(inspection))
        {
            this.onExpand(inspection);
        }
    }

    onRowEditCancel(inspection: InspectionView) {
        this.dataSource.data[this.dataSource.data.findIndex(x => x.UnitId === inspection.UnitId)] = this.clonedList[this.getDictionaryHash(inspection)];
        delete this.clonedList[this.getDictionaryHash(inspection)];
        if (Object.keys(this.clonedList).length === 0) this.saveService.showSaveButton(false)
        this.table.renderRows();
    }

    onShowSavebutton() {
        this.saveService.showSaveButton();
    }

    onSave() {
        let updatedList: any[] = []
        for (let i in this.clonedList) {
            let index = this.dataSource.data.findIndex(x => x.InspectionId === this.clonedList[i].InspectionId)
            var item = { ...this.dataSource.data[index].Details[0], ...this.dataSource.data[index] }
            updatedList.push(item)
        }
        Utils.httpUpdateInspections(
            this.http
            , this.baseUrl
            , this.defaults.stage
            , updatedList
            , this
            , function (tthis: any, list: InspectionView[]) {
                tthis.toastrService.success('Inspection(s) were updated successfully!');
                tthis.clonedList = {}
                tthis.saveService.showSaveButton(false)
                tthis.expandedElements.clear();
                tthis.table.renderRows();
            }
            , function (tthis: InspectionListComponent, message: string) {
                tthis.saveService.showSaveButton(true)
                tthis.saveService.addListener(tthis)
                tthis.confirmDialog.showErrorDialog(message);
            }
        );
    }

    applyFilter(event: MatChipInputEvent): void {
        const input = event.input;
        const value = event.value;
        if ((value || '').trim()) {
            this.searchItems.push({ name: value.replace('+', '').trim() });
        }
        // Reset the input value
        if (input) {
            input.value = '';
        }
        this.updatefilter()
    }

    remove(item: SearchItem): void {
        const index = this.searchItems.indexOf(item);
        if (index >= 0) {
            this.searchItems.splice(index, 1);
        }
        this.updatefilter()
    }

    changeSubsLevel(value: any, element: InspectionDetailsView) {
        this.table.renderRows();
    }

    updatefilter() {
        let filterString: string
        if (this.searchItems.length === 0) {
            this.dataSource.filter = 'notextfilters'
        }
        else {
            filterString = this.searchItems.map(e => { return e.name }).join('+') + '+checkboxes'
            this.dataSource.filter = filterString
        }
    }

    getDictionaryHash(inspection: InspectionView) {
        return inspection.InspectionId + inspection.UnitId
    }

    getDateFormat(property: string): string {
        if (this.dateColumnsFormatYYYYMMDDHHmm.indexOf(property) > -1) {
            return 'yyyy-MM-dd HH:mm';
        }
        else {
            return 'yyyy-MM-dd';
        }
    }

    getDateUTCChange(event, data: ContactInfoHub, property: string) {
        let utcDate = Utils.dateUTCchange(event);
        data[property] = utcDate;
    }
    openChangeHistoryDialog(element: any) {
        const filteredElement = element ? Object.fromEntries(
            Object.entries(element).filter(([key]) => this.columnsToDisplay.includes(key))
        ) : undefined;
        if (filteredElement && element.TenantId) {
            filteredElement["TenantId"] = element.TenantId;
        }
        this.dialog.open(ChangeHistoryDialogue, {
            height: '535px',
            width: '900px',
            data: {
                entity: 'Inspections',
                row: filteredElement,
            }
        });
    }
}

export interface SearchItem {
    name: string;
}